import styles from "./style.module.scss";
import React from "react";
import MeetUsWrapper from "Components/MeetUsWrapper";
import MetaverseEvents from "../../../Utils/Assets/Images/Metaverse Events.png";
import FeatureHostEarningImage from "../../../Utils/Assets/Images/FeatureHostEarningImage.png";
import Database from "../../../Utils/Assets/Images/Database.png";
import ImageSquare from "../../../Utils/Assets/Images/ImageSquare.png";
import Users from "../../../Utils/Assets/Images/Users.png";
import VR from "../../../Utils/Assets/Images/VR.png";

const FeatureHostEarnings = () => {
    return (
        <div className={styles.featureHostEarnings}>
            <MeetUsWrapper>
                <div className={styles.earningsWrapper}>
                    <div className={styles.earningsContainer}>
                        <div className={styles.earningsCard}>
                            <div
                                className={styles.earningsImageWrapper}
                                data-aos="fade-right"
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <div className={styles.earningsPhoneFrame}>
                                    <img
                                        src={MetaverseEvents}
                                        alt="Metaverse Events"
                                        className={styles.MetaverseEvents}
                                    />
                                </div>
                                <img
                                    src={FeatureHostEarningImage}
                                    alt="Feature Host Earning"
                                    className={styles.FeatureHostEarningImage}
                                />
                            </div>

                            <div
                                className={styles.earningsContent}
                                data-aos="fade-left"
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <div className="">
                                    <button
                                        className={styles.featureHeaderButton}
                                    >
                                        About Features
                                    </button>
                                </div>
                                <div className={styles.earningsTextWrapper}>
                                    <h1 className={styles.earningsTitle}>
                                        Get Paid to Host Virtual Events!
                                    </h1>
                                    <p className={styles.earningsDescription}>
                                        Turn your meetings, concerts, and
                                        discussions into earning opportunities.
                                        Every guest interaction rewards you with
                                        MVR Coins!
                                    </p>
                                </div>
                                <div className={styles.earningsFlex}>
                                    <div className={styles.earningsFlexItem}>
                                        <img src={Users} alt="Users" />
                                        <p className={styles.earningsFlexText}>
                                            Virtual Meetups & Networking
                                        </p>
                                    </div>

                                    <div className={styles.earningsFlexItem}>
                                        <img src={ImageSquare} alt="Users" />
                                        <p className={styles.earningsFlexText}>
                                            Interactive VR Venues
                                        </p>
                                    </div>

                                    <div className={styles.earningsFlexItem}>
                                        <img src={VR} alt="Users" />
                                        <p className={styles.earningsFlexText}>
                                            Interactive VR Games
                                        </p>
                                    </div>

                                    <div className={styles.earningsFlexItem}>
                                        <img src={Database} alt="Users" />
                                        <p className={styles.earningsFlexText}>
                                            Host & Earn MeetusVR Coins
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default FeatureHostEarnings;
